// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w0Gx","col":"styles_col__2CmK4"};